"use strict";

var LoggerInstance = require("js-logger").get("OneTimePassword");

var OneTimePasswordApi = require("../api/OneTimePasswordApi");

var ApiHelper = require("../shared/ApiHelper");

var Constants = require("../designer/Constants");
const BootstrapPrompt = require("../shared/BootstrapPrompt");

var oneTimePasswordPopupSelector = "[data-component='oneTimePassword']"
var oneTimePasswordVerificationCodeInputSelector = "[data-component='oneTimePassword.input']"
var oneTimePasswordCancelSelector = ".one-time-password-abort";
var oneTimePasswordSubmitSelector = ".one-time-password-submit";
var oneTimePasswordResendSelector = ".one-time-password-resend";

var OneTimePassword = {
	initialize: function (oneTimePasswordOptions) {
		oneTimePasswordOptions = oneTimePasswordOptions || {};
		window.oneTimePasswordInstances = window.oneTimePasswordInstances || {};
		this.oneTimePasswordOptions = oneTimePasswordOptions;

		this.emailAddressVerifiedAttribute = "data-email-address-user-verified";

		var oneTimePasswordErrorMessagesWizard = window.CheckoutActions.getOneTimePasswordErrorMessages();
		this.invalidOneTimePasswordMessage = oneTimePasswordErrorMessagesWizard && oneTimePasswordErrorMessagesWizard.invalidOneTimePassword || "One Time Password is invalid.";

		this.isResending = false;

		if (!oneTimePasswordOptions.instanceName) {
			LoggerInstance.error("An 'instanceName' must be provided.");
			return;
		}
		if (window.oneTimePasswordInstances[oneTimePasswordOptions.instanceName]) {
			LoggerInstance.error(`A OneTimePassword instance already exists with the '${oneTimePasswordOptions.instanceName}' instanceName.`);
		}

		var $createAccountForm = $(oneTimePasswordOptions.createAccountFormSelector);
		var themeId = $createAccountForm.attr("data-theme") || $("body").attr("data-theme");
		this.instanceName = oneTimePasswordOptions.instanceName;

		if ($createAccountForm.length && themeId) {
			OneTimePasswordApi.getOneTimePasswordHtml(themeId).done((data) => {
				if (data.success) {
					// Just got the Popup and OTP Generate html
					oneTimePasswordOptions = Object.assign(oneTimePasswordOptions, data.model);
					this.oneTimePasswordModalHtml = oneTimePasswordOptions.oneTimePasswordHtml;

					// Save the OneTimePasswordInstance
					this.initialized = true;
					window.oneTimePasswordInstances[oneTimePasswordOptions.instanceName] = this;
				}
			});
		}
	},

	initializeForCreateAccount: function() {
		// Setting up the createAccountForm OneTimePassword form
		this._initializeForm("#createAccountForm", "createAccountForm");
	},

	_initializeForm: function(formSelector, instanceName) {
		var oneTimePasswordOptions = {
			instanceName,
			createAccountFormSelector: formSelector,
			emailAddressSelector: `${formSelector} input[data-component='accountEmailAddress']`,
		};
		this.initialize(oneTimePasswordOptions);

		var isOneTimePasswordRequired = CheckoutActions.getOneTimePasswordRequired();
		var $accountEmailAddress = $(formSelector).find("[data-component='accountEmailAddress']");
		if (isOneTimePasswordRequired) {
			$accountEmailAddress.attr("required", "required");
		}
	},

	clearVerification: function(instanceName) {
		if (!instanceName) {
			return ApiHelper.logErrorAndReturnResolvedDeferred(LoggerInstance, "An 'instanceName' must be provided.");
		}

		if (window.oneTimePasswordInstances && window.oneTimePasswordInstances[instanceName] && (typeof window.oneTimePasswordInstances[instanceName].clearVerification === "function")) {
			return window.oneTimePasswordInstances[instanceName].clearVerification();
		}

		return ApiHelper.logDebugAndReturnResolvedDeferred(LoggerInstance, `A OneTimePassword instance with the instanceName '${instanceName}' does not exist.`);
	},

	_isValid(data) {
		return data && data.response && data.response.isMatched;
	},

	_showAndAddClickEvents(html, deferred) {
		var $popup = $(html).hide().appendTo("body");

		$popup.find(oneTimePasswordPopupSelector).addBack(oneTimePasswordPopupSelector).css({
			left: `calc(50% - ${($popup.width() / 2)}px)`,
			top: "25%",
			position: "fixed"
		});

		$popup.show();

		//Adding Click Events
		$popup.find(oneTimePasswordCancelSelector).click(() => {
			//Constituent wants to go back and correct or ignore.
			this._removePopup($popup);
			deferred.reject();
		});

		$popup.find(oneTimePasswordSubmitSelector).click(() => {
			//Constituent wants to verify the email.
			var oneTimePassword = $(oneTimePasswordVerificationCodeInputSelector).val();
			this._removePopup($popup);
			deferred.resolve(oneTimePassword);
		});

		$popup.find(oneTimePasswordResendSelector).click(() => {
			//Constituent wants to resend the email.
			try {
				if (this.isResending) {
					return;
				} else {
					this.isResending = true;
				}

				this._verifyOneTimePassword(this.instanceName, deferred, /*isResending*/ true);
			}
			catch (e) {
				BootstrapPrompt.alert("Unable to resend the One Time Password verification email.");
			};
		});

		//Escape linked to go back.
		$(document).on("keydown", { $popup }, this._popupEscapeHandler);
	},

	_showOneTimePasswordModal(deferred) {
		var $oneTimePasswordHtmlElement = $(this.oneTimePasswordModalHtml); 

		this._showAndAddClickEvents($oneTimePasswordHtmlElement, deferred);
	},

	_generatePasswordSuccess(deferred) {
		if (!this.isResending) {
			this._showOneTimePasswordModal(deferred);
		}
		return deferred;
	},

	_handleGeneratePasswordError(jqXHR, textStatus, errorThrown, instanceName) {
		BootstrapPrompt.alert("Unable to generate the One-Time Password.");
		LoggerInstance.error(`Unable to generate the One-Time Password for the instanceName '${instanceName}'.`);
	},

	_verifyOneTimePassword: function (instanceName, deferred) {
		deferred = deferred || new $.Deferred();
		if (!instanceName) {
			return ApiHelper.logErrorAndReturnResolvedDeferred(LoggerInstance, "An 'instanceName' must be provided.");
		}

		this.verifying = true;
		var emailAddress = $(this.oneTimePasswordOptions.emailAddressSelector).val()

		if (!emailAddress) {
			BootstrapPrompt.alert("Email could not be sent. Contact your system administrator.");
			deferred.reject();
			return;
		}

		OneTimePasswordApi.generateOneTimePassword({
			email: emailAddress,
		}).done((response) => {
			this.generatingOneTimePassword = false;
			this._generatePasswordSuccess(deferred)
				.done((oneTimePassword) => {
					deferred.resolve(oneTimePassword);
				}).fail(() => {
					deferred.reject();
				});

			if (this.isResending) {
				BootstrapPrompt.success("One Time Password has been resent.");
				this.isResending = false;
			}
		}).fail((jqXHR, textStatus, errorThrown) => {
			this.generatingOneTimePassword = false;
			this._handleGeneratePasswordError(jqXHR, textStatus, errorThrown, instanceName);
			deferred.reject();
		});

		return deferred;
	},

	_popupEscapeHandler(event) {
		if (!event || !event.data) {
			LoggerInstance.error("Event or Event Data not present in Popup Escape Handler");
			return;
		}

		switch (event.which) {
			case Constants.KEYS.ESCAPE:
				$(event.data.$popup).find(oneTimePasswordCancelSelector).click();
				break;
		}
	},

	_removePopup($popup) {
		$(document).off("keydown", this._popupEscapeHandler);
		$popup.remove();
	},

	validatePassword: function (instanceName, deferred) {
		if (!instanceName) {
			return ApiHelper.logErrorAndReturnResolvedDeferred(LoggerInstance, "An 'instanceName' must be provided.");
		}

		this._verifyOneTimePassword(instanceName, deferred);

		return deferred;
	},

	verifyOneTimePassword: function (instanceName) {
		if (!instanceName) {
			return ApiHelper.logErrorAndReturnResolvedDeferred(LoggerInstance, "An 'instanceName' must be provided.");
		}

		if (window.oneTimePasswordInstances && window.oneTimePasswordInstances[instanceName] && (typeof window.oneTimePasswordInstances[instanceName].verifyAddress === "function")) {
			return window.oneTimePasswordInstances[instanceName].verifyOneTimePassword();
		}

		return ApiHelper.logDebugAndReturnResolvedDeferred(LoggerInstance, `A OneTimePassword instance with the instanceName '${instanceName}' does not exist.`);
	}
};

module.exports = OneTimePassword;
